/*
 * @Descripttion: 关于我们
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-21 09:42:26
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 10:58:00
 */

const about = {
  about: {
    title: 'About ArteryFlow Technology',
    des: '',
    list: [
      'Hangzhou ArteryFlow Technology Co., Ltd. (hereinafter referred to as " ArteryFlow Technology"), founded in June 2017, is a national high-tech enterprise providing leading intelligent solutions for cardiovascular and cerebrovascular diseases worldwide.',
      'As an innovator in the field of cardiovascular and cerebrovascular intelligent diagnosis and treatment, ArteryFlow Technology upholds the concept of "Bringing precision to medcine" and aim to become the world\'s leading precision clinical ecological platform.',
      'We have launched a series of platform-based pipeline products covering the cardiovascular and cerebrovascular fields relying on the technical precipitation in medical big data, computational simulation, hemodynamics, AI algorithms, etc., and achieved the whole process of screening, detection, diagnosis, surgery and treatment. ',
      'In the future, we will build a precision clinical ecological closed loop covering both in-hospital and out-of-hospital scenarios, provide precision and personalized diagnosis and treatment services for hospitals, imaging centers, medical institutions and patients, and bring a better diagnosis and treatment experience.'
    ]
  },
  culture: {
    title: 'Our Culture',
    list: [
      {
        title: 'Vision',
        des: 'Bringing precision to medicine'
      }, {
        title: 'Mission',
        des: "Provide the world's leading intelligent solutions for cardiovascular and cerebrovascular diseases"
      }, {
        title: 'Values',
        des: 'Innovation, precision, efficiency and excellence'
      }, {
        title: 'Slogan',
        des: 'Lead the way in cardiovascular and cerebrovascular intelligent treatment'
      }
    ]
  },
  international: {
    title: 'International Influence',
    list: [
      "With profound accumulation in deep learning, hemodynamic analysis, medical imaging processing and other fields since establishment, ArteryFlow Technology's innovative products have been continuously recognized by the global industry.",
      'In December 2019, AccuFFR series products were awarded the Annual Cardiovascular Best Innovation Award at the International Conference for Innovations in Cardiovascular Interventions (ICI) in Israel.',
      'In March 2020, AccuFFR series products were marked by the European Union CE. ArteryFlow Technology became the first company having both CT-FFR and angio-FFR products with independent software and hardware products in the CE market.',
      'In November 2020, ArteryFlow Technology stood out from 100 award-winning innovative projects in the 4th World Life Science and Technology Conference and was awarded the only first prize of the SATOL Innovation Award .',
      'In April 2021, three products of AccuFFR series were simultaneously approved for the Chinese Medical Device Market Registration Certificate by the CN NMPA. AneuFlow was approved and became the first intracranial aneurysm evaluation system based on hemodynamics in China.',
      'In February 2022, AneuSize was approved for the Special Review for the China Class III Innovative Medical Devices by the CN NMPA.',
      'In June 2022, AneuGuide was cleared by the US FDA 510(k), and became the only flow diverter surgery planning software with clearance of the US FDA.',
      'In December 2022, AccuCTP was officially cleared by US FDA 510(k), becoming the only CTP image analysis software with market permission from both CN NMPA and US FDA.',
      'In January 2023, AccuIMR was approved for for the Special Review for the China Class III Innovative Medical Devices by the CN NMPA.',
      'In February 2023, AccuICAS was cleared by US FDA 510(k), and became the globally unique approved product for intracranial stenosis functional assessment.',
      'In March 2023, AccuFFRangio Plus was approved by CN NMPA and was cleared by US FDA 510(k).'
    ]
  },
  history: {
    title: 'Milestones',
    year: [2023, 2022, 2021, 2020, 2019, 2018, 2017],
    list: [
      {
        time: 2023,
        des: [
          {
            time: 'January',
            content: 'AccuIMR, the coronary microcirculation functional assessment product, was approved for the Special Review for China Class III Innovative Medical Devices by the CN NMPA.'
          }, {
            time: 'February',
            content: 'AccuICAS, the intracranial stenosis functional assessment product, was cleared by the US FDA 510(k).'
          }, {
            time: 'March',
            content: 'AccuFFRangio Plus, the coronary functional assessment device, was approved for the registration certificate of China Class III Medical Devices by the CN NMPA. '
          }, {
            time: 'March',
            content: 'AccuFFRangio Plus, the coronary functional assessment device, was cleared by the US FDA 510(k).'
          }, {
            time: 'March',
            content: 'ArteryFlow Technology launched the coronary function surgery plan product and the microcirculation evaluation product at CTOCC conference, and conducted live surgery broadcast.'
          }
        ]
      },
      {
        time: 2022,
        des: [
          {
            time: 'February',
            content: 'AneuSize, the intracranial aneurysm intraoperative real-time planning system, was approved for the Special Review for China Class III Innovative Medical Devices by the CN NMPA.'
          }, {
            time: 'May',
            content: 'QFR-A, the coronary functional assessment product, was approved for the registration certificate by the CN NMPA.'
          }, {
            time: 'June',
            content: 'ArteryFlow Technology was honored to be listed in the “2022 Future Medical 100 · Innovative Medical Device TOP 100” and was awarded the “Future Medical 100 · Pengcheng Award·Annual Innovation Enterprise Award”.'
          }, {
            time: 'June',
            content: 'AneuGuide, the intracranial aneurysm intraoperative real-time planning system, was cleared by the US FDA 510(k).'
          }, {
            time: 'August',
            content: 'ArteryFlow Technology co-launched the “Intelligent Drawing Cloud College Project of Cerebrovascular Disease Imaging Aided Diagnosis Application” with the Chinese Stroke Association.'
          }, {
            time: 'August',
            content: 'The first “ArteryFlow Refueling Station & Cooperative Partner Training Conference” was held.'
          }, {
            time: 'September',
            content: 'AccuOCT, the coronary functional assessment product, was approved for the registration certificate by the CN NMPA.'
          }, {
            time: 'November',
            content: "ArteryFlow Technology's founder and CEO, Dr. Jianping Xiang, was selected as the National Leading Talent in 2022."
          }, {
            time: 'December',
            content: 'AccuCTP, the cerebral CT perfusion analysis product, was cleared by the US FDA 510(k).'
          }, {
            time: 'December',
            content: 'ArteryFlow Technology co-established the OCI Hemodynamics Joint Laboratory with the Oriental Cerebrovascular Disease Innovation Club.'
          }
        ]
      },
      {
        time: 2021,
        des: [
          {
            time: 'April',
            content: 'AneuFlow-01/03/04, three versions of the intracranial aneurysm hemodynamic assessment product, were approved for the registration certificate by the CN NMPA.'
          }, {
            time: 'April',
            content: 'AccuAngio, the coronary functional assessment product, was approved for the registration certificate by the CN NMPA.'
          }, {
            time: 'April',
            content: 'AccuCT, the coronary functional assessment product, was approved for the registration certificate by the CN NMPA.'
          }, {
            time: 'May',
            content: 'ArteryFlow Technology launched the cardio-cerebrovascular functional assessment products launch conference at the OCC Conference, .'
          }, {
            time: 'June',
            content: 'ArteryFlow Technology completed Series B funding of nearly 100 million CNY.'
          }, {
            time: 'September',
            content: 'AccuFFRangio, the coronary functional assessment product, was cleared by the US FDA.'
          }, {
            time: 'October',
            content: 'ArteryFlow Technology co-established the Hemodynamics Joint Laboratory with the Center for Cardiovascular Innovations (CCI).'
          }, {
            time: 'October',
            content: 'AneuGuide, the intracranial aneurysm intraoperative real-time planning system, was approved for the Special Review for the China Class II Innovative Medical Devices and was approved for the registration certificate by the CN NMPA.'
          }, {
            time: 'December',
            content: 'AccuCTP, the cerebral CT perfusion analysis product, was approved for the registration certificate by the CN NMPA.'
          }
        ]
      }, {
        time: 2020,
        des: [
          {
            time: 'March',
            content: 'AccuFFR, the coronary functional assessment product series, was marked by the European Union CE.'
          }, {
            time: 'May',
            content: 'ArteryFlow Technology was awarded “China Medical Health Industry Best Newcomer Award”.'
          }, {
            time: 'July',
            content: 'AneuFlow-02, the intracranial aneurysm morphological analysis product, was approved for the registration certificate by the CN NMPA.'
          }, {
            time: 'September',
            content: 'AccuFFR, the coronary functional assessment product series, was awarded the “Zhejiang Province Health Science and Technology Achievement Transformation Gold Award”.'
          }, {
            time: 'November',
            content: 'ArteryFlow Technology was awarded the only first prize of the Innovation Award in the 4th World Life Science and Technology Conference.'
          }
        ]
      }, {
        time: 2019,
        des: [
          {
            time: 'May',
            content: 'ArteryFlow Technology launched The Old Partner Case System at the QICC Conference.'
          }, {
            time: 'June',
            content: 'ArteryFlow Technology completed Series A funding of nearly 10 million CNY.'
          }, {
            time: 'September',
            content: 'Three products of AccuFFR, the coronary functional assessment product series, were launched and used in surgical live broadcast at the QICC Conference.'
          }, {
            time: 'December',
            content: 'ArteryFlow Technology was awarded “National High-tech Enterprise”.'
          }, {
            time: 'December',
            content: 'ArteryFlow Technology was listed in the “2019 Future Medical 100 List”.'
          }, {
            time: 'December',
            content: 'ArteryFlow Technology completed Series A+ funding of nearly 10 million CNY and introduced strategic investor China Pharmaceutical Capital.'
          }, {
            time: 'December',
            content: 'AccuFFR, the coronary functional assessment product series, was awarded the Annual Cardiovascular Best Innovation Award at the International Conference for Innovations in Cardiovascular Interventions (ICI) in Israel.'
          }
        ]
      }, {
        time: 2018,
        des: [
          {
            time: 'April',
            content: 'ArteryFlow Technology was selected as the “Hangzhou Binjiang 5050 Key Supported Enterprise”.'
          }, {
            time: 'May-August',
            content: 'ArteryFlow Technology was awarded Hangzhou Key Cultivated Enterprise, Zhejiang Province Science and Technology Small and Medium-sized Enterprises, and National Science and Technology Small and Medium-sized Enterprises.'
          }, {
            time: 'September',
            content: 'AccuFFR, the coronary functional assessment product series, was launched At the QICC Conference.'
          }
        ]
      }, {
        time: 2017,
        des: [
          {
            time: 'June',
            content: 'ArteryFlow Technology was founded.'
          }, {
            time: 'October',
            content: 'ArteryFlow Technology completed the angel funding of tens million CNY.'
          }
        ]
      }
    ]
  }
}

export default about
